class SiteHeader {
    constructor(element) {
        this.el = element;

        this.init();
    }

    init() {
        // this.setupSearchForm();
        this.setupEmailFocus();
    }

    setupSearchForm() {
        const searchForm = document.querySelector(".site-header__search");

        if (!searchForm) {
            return;
        }

        new Disclosure(searchForm, {
            collapseOnEscape: true,
            collapseOnFocusout: true,
            focusWithinOnExpand: true,
            setHiddenAttribute: false,
        });
    }

    setupEmailFocus() {
        // Wait for Gravity Forms fields to be fully loaded
        setTimeout(() => {
            const emailField = document.querySelector(
                '.mailing-list .gform-body input[type="email"]',
            );
            const otherFields = document.querySelectorAll(
                ".mailing-list .gfield:not(.gfield--type-email):not(.gfield--type-submit)",
            );
            const privacyNote = document.querySelector(
                ".mailing-list p.type-body-s",
            );

            if (!emailField) {
                console.warn(
                    "Email field not found. Ensure Gravity Forms is loaded.",
                );
                return;
            }

            // Hide fields initially
            otherFields.forEach((field) => (field.style.display = "none"));

            if (privacyNote) {
                privacyNote.style.display = "none";
            }

            // Use event delegation to handle dynamically loaded fields
            document.addEventListener("focusin", (event) => {
                if (event.target === emailField) {
                    otherFields.forEach((field) => {
                        if (window.innerWidth >= 768) {
                            field.style.display = "inline-block";
                        } else {
                            field.style.display = "block";
                        }
                    });

                    if (privacyNote) {
                        privacyNote.style.display = "block";
                    }
                }
            });
        }, 500); // Delay to allow Gravity Forms to load
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector(".site-header");

    if (element) {
        new SiteHeader(element);
    }
});
